import { Observable, of } from 'rxjs'
import { CanvasService } from '../canvas.service'
import { CanvasArgs, CanvasBaseCommand, CanvasCommandType } from './canvas-command.model'

export interface AddItemArgs extends CanvasArgs {
  /** Client-side delegate that opens the dialog and inserts the item. */
  action?: () => void
}

export class AddItemCommand extends CanvasBaseCommand<AddItemArgs> {
  readonly id = 'add-item'
  readonly type: CanvasCommandType = 'dialog-invoker'
  override icon = 'add'
  override label = 'Add Item'
  override tooltip = 'Add daydic item to canvas'

  constructor(canvasService: CanvasService) {
    super(canvasService)
  }

  override enabled(args?: AddItemArgs): boolean {
    return !!args?.canvasId
  }

  protected doExecute(args?: AddItemArgs): Observable<boolean> {
    args?.action?.()
    return of(true)
  }
}
